import { render, staticRenderFns } from "./daraftListTravel.vue?vue&type=template&id=41f4ff1b&scoped=true"
import script from "./daraftListTravel.vue?vue&type=script&lang=js"
export * from "./daraftListTravel.vue?vue&type=script&lang=js"
import style0 from "./daraftListTravel.vue?vue&type=style&index=0&id=41f4ff1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f4ff1b",
  null
  
)

export default component.exports